// extracted by mini-css-extract-plugin
export default {"selected":"styles-module__selected__src-labstep-web-components-ResourceLocation-MapModal-Content-Right-List-_Jvqk8"};